import { gql, useQuery } from "@apollo/client";
import { ErrorComponent } from "@src/components";
import Summary from "@src/components/summary/Summary";
import { type GQLCameraSummaryDashboardAdminQuery, type GQLCameraSummaryDashboardAdminQueryVariables } from "@src/graphql.generated";
import CameraActive from "@src/icons/CameraActive";
import CameraDeleted from "@src/icons/CameraDeleted";
import CameraWithLicence from "@src/icons/CameraWithLicence";
import CameraWithoutLicence from "@src/icons/CameraWithoutLicence";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const cameraSummaryDashboardAdminQuery = gql`
    query CameraSummaryDashboardAdmin {
        cameraSummaryDashboardAdmin {
            activatedCamerasCount
            deletedCamerasCount
            camerasWithLicencesCount
            camerasWithoutLicencesCount
        }
    }
`;

const CamerasSummary: FC<PropsWithChildren> = () => {
    const { data, error } = useQuery<GQLCameraSummaryDashboardAdminQuery, GQLCameraSummaryDashboardAdminQueryVariables>(
        cameraSummaryDashboardAdminQuery,
    );
    const intl = useIntl();

    const summaryItems = [
        {
            count: data?.cameraSummaryDashboardAdmin.activatedCamerasCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.activatedCamerasCount" defaultMessage="Aktivierte Kameras" />,
            icon: <CameraActive fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryDashboardAdmin.deletedCamerasCount,
            text: (
                <FormattedMessage id="reviermanager.page.dashboard.summary.deletedCamerasCount" defaultMessage="gelöschte Kameras letzte 30 Tage" />
            ),
            icon: <CameraDeleted fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryDashboardAdmin.camerasWithLicencesCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.camerasWithLicence" defaultMessage="Kameras mit Lizenz" />,
            icon: <CameraWithLicence fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryDashboardAdmin.camerasWithoutLicencesCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.camerasWithoutLicence" defaultMessage="Kameras ohne Lizenz" />,
            icon: <CameraWithoutLicence fontSize="large" color="primary" />,
        },
    ];

    if (error) {
        return <ErrorComponent />;
    }

    return (
        <Summary
            items={summaryItems}
            title={intl.formatMessage({ id: "reviermanager.page.dashboard.summary.devices", defaultMessage: "Kameras" })}
            variant="dashboard"
        />
    );
};

export default CamerasSummary;
